module.exports = {"511123100":"玉津镇","511123101":"孝姑镇","511123102":"石溪镇","511123103":"清溪镇","511123104":"新民镇","511123105":"罗城镇","511123106":"芭沟镇","511123107":"龙孔镇","511123108":"定文镇","511123109":"敖家镇","511123110":"金石井镇","511123111":"泉水镇","511123200":"双溪乡","511123201":"九井乡","511123202":"同兴乡","511123203":"榨鼓乡","511123204":"铁炉乡","511123205":"大兴乡","511123206":"南阳乡","511123207":"纪家乡","511123208":"新盛乡","511123209":"寿保乡","511123210":"舞雩乡","511123211":"下渡乡","511123212":"玉屏乡","511123213":"岷东乡","511123214":"塘坝乡","511123215":"马庙乡","511123216":"公平乡","511123217":"伏龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511123.json
// module id = 2150
// module chunks = 0